import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import Loader from "../Loader";

export default lazyPage(
    "src/front/components/Experience/Experience.tsx",
    () => import("./Experience"),
    <Loader margin="auto" />,
);
